<template>
  <div class="helpbox-wrapper">
    <div class="helpbox">
      <div
        class="button black"
        @click="handleOpenModal"
        style="min-width: initial; max-width: initial"
      >
        <span class="button__label">Hast du Fragen</span
        ><svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.8521 9.25C17.8521 4.46875 13.9146 0.53125 9.13336 0.53125C4.31696 0.53125 0.414612 4.46875 0.414612 9.25C0.414612 14.0664 4.31696 17.9688 9.13336 17.9688C13.9146 17.9688 17.8521 14.0664 17.8521 9.25ZM9.3443 3.41406C11.3482 3.41406 13.4576 4.96094 13.4576 7C13.4576 9.74219 10.5396 9.77734 10.5396 10.7617V10.7969C10.5396 11.043 10.3287 11.2188 10.1177 11.2188H8.14899C7.90289 11.2188 7.72711 11.043 7.72711 10.7969V10.6562C7.72711 9.21484 8.81696 8.65234 9.62555 8.19531C10.3287 7.80859 10.7857 7.52734 10.7857 7C10.7857 6.29688 9.87164 5.83984 9.16852 5.83984C8.2193 5.83984 7.79742 6.29688 7.16461 7.10547C7.02399 7.28125 6.74274 7.31641 6.56696 7.17578L5.33649 6.26172C5.16071 6.12109 5.12555 5.875 5.26617 5.66406C6.21539 4.22266 7.44586 3.41406 9.3443 3.41406ZM9.13336 12.1328C10.0123 12.1328 10.7505 12.8711 10.7505 13.75C10.7505 14.6641 10.0123 15.3672 9.13336 15.3672C8.2193 15.3672 7.51617 14.6641 7.51617 13.75C7.51617 12.8711 8.2193 12.1328 9.13336 12.1328Z"
            fill="#fff"
          ></path>
        </svg>
      </div>
      <div class="helpbox-tooltip-content">
        <HelpboxContent :onClose="closeModal"/>
      </div>
    </div>
    <HelpboxModal :isOpen="this.showModal" @close="closeModal" />
  </div>
</template>

<script>
import HelpboxModal from "../components/modals/HelpboxModal.vue";
import HelpboxContent from "./HelpboxContent.vue";
export default {
  name: "Helpbox",
  data () {
    return { showModal: false }
  },
  components: {
    HelpboxContent,
    HelpboxModal,
  },
  methods: {
    handleOpenModal () {      
      const isMobileScreen = window.innerWidth <= 2150;
      if (isMobileScreen) {        
        this.openModal();
      }
    },
    openModal () {
      this.showModal = true;
    },
    closeModal () {
      this.showModal = false;
    },
  },
};
</script>

<style lang="scss">
.button {
  align-items: center;
  border-radius: 50px;
  cursor: pointer;
  display: inline-flex;
  flex-direction: row;
  gap: 10px;
  height: 56px;
  justify-content: center;
  padding: 15px 40px;
  transition: all 0.3s ease;
  white-space: nowrap;
  &.black {
    background: #000;
    color: #fff;
  }
}
.helpbox {
  position: fixed;
  top: 80%;
  left: calc((100vw - 1620px) / 2 - 150px);
  transform: translateX(-50%);
  z-index: 100;

  @media (min-width: 2150px) {
    &:hover {
      .helpbox-tooltip-content {
        opacity: 1;
        visibility: visible;
      }
    }
  }

  @media (max-width: 2150px) {
    bottom: 15px;
    left: 40px;
    top: initial;
    
    .button {
      padding: 15px 20px;
      box-shadow: 2px 2px 20px rgba(0, 0, 0, .25);
    }
    .button__label {
      display: none;
      padding: 15px 20px;
    }
  }

  &-modal {
    position: absolute;
    background: none !important;
    outline: none;
    max-width: 430px;
    min-width: initial !important;

    .modal__close-button {
      color: #fff;

      svg path {
        fill: #fff;
      }
    }
  }
}

.helpbox-item {
  font-size: 13px;

  display: flex;
  align-items: center;
  gap: 20px;

  border: 1px solid #c0141b;
  border-radius: 50px;
  padding: 14px 20px;
  margin-bottom: 10px;
  cursor: pointer;
  background-color: #fff;

  &:hover {
    background-color: #ffe0e424;
    transition: all 0.2s;
  }

  &:last-child {
    margin-bottom: 0;
  }
}

.helpbox-tooltip-content {
  position: absolute;
  top: -50%;
  left: 50%;
  transform: translate(-50%, -100%);
  z-index: 1;

  opacity: 0;
  visibility: hidden;
  transition: 0.2s ease-in-out;
}

.helpbox__content {
  width: 320px;
  padding: 0 28px 28px;
  border-top: 1px solid #c0141b;
  background-color: #fff;
  filter: drop-shadow(0px 0px 15px rgba(0, 0, 0, 0.15));

  @media (min-width: 2150px) {
    &::before {
      content: "";
      width: 25px;
      height: 25px;
      background: #ffffff;
      transform: rotate(45deg);
      position: absolute;
      bottom: -10px;
      left: 45%;
    }
  }
}

.helpbox-modal .helpbox__content {
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/landing-components/Helpbox.vue